const body = document.body;
const menuToggle = document.querySelector("[data-menu-toggle]");
const mobileNav = document.querySelector("[data-mobile-nav]");
const heroCarousel = document.querySelector("[data-hero-carousel]");
const headerStyleSearch = document.querySelector("[data-header-style-search]");
const headerStyleSearchToggle = document.querySelector("[data-header-style-search-toggle]");
const headerStyleSearchInput = headerStyleSearch?.querySelector("[data-style-search-input]");

menuToggle?.addEventListener("click", () => {
  const isOpen = body.classList.toggle("menu-open");
  menuToggle.setAttribute("aria-label", isOpen ? "Close navigation" : "Open navigation");
});

mobileNav?.addEventListener("click", (event) => {
  if (event.target instanceof HTMLAnchorElement) {
    body.classList.remove("menu-open");
    menuToggle?.setAttribute("aria-label", "Open navigation");
  }
});

headerStyleSearchToggle?.addEventListener("click", () => {
  const isOpen = headerStyleSearch?.classList.toggle("is-open");
  headerStyleSearchToggle.setAttribute("aria-expanded", String(Boolean(isOpen)));
  if (isOpen) window.setTimeout(() => headerStyleSearchInput?.focus(), 0);
});

document.addEventListener("click", (event) => {
  if (!headerStyleSearch?.classList.contains("is-open")) return;
  if (event.target instanceof Node && headerStyleSearch.contains(event.target)) return;
  headerStyleSearch.classList.remove("is-open");
  headerStyleSearchToggle?.setAttribute("aria-expanded", "false");
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape" || !headerStyleSearch?.classList.contains("is-open")) return;
  headerStyleSearch.classList.remove("is-open");
  headerStyleSearchToggle?.setAttribute("aria-expanded", "false");
  headerStyleSearchToggle?.focus();
});

if (heroCarousel) {
  const slides = [...heroCarousel.querySelectorAll("[data-hero-slide]")];
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  let activeIndex = 0;
  let rotation;

  const showSlide = (nextIndex) => {
    activeIndex = (nextIndex + slides.length) % slides.length;

    slides.forEach((slide, index) => {
      const isActive = index === activeIndex;
      slide.classList.toggle("is-active", isActive);
      slide.setAttribute("aria-hidden", String(!isActive));
    });

    heroCarousel.classList.toggle("has-light-copy", slides[activeIndex]?.dataset.copyTheme === "light");
  };

  const stopRotation = () => window.clearInterval(rotation);
  const startRotation = () => {
    if (reduceMotion || slides.length < 2) return;
    stopRotation();
    rotation = window.setInterval(() => showSlide(activeIndex + 1), 5500);
  };

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) stopRotation();
    else startRotation();
  });
  startRotation();
}
